import { render } from "./DetalharPessoaJuridica.vue?vue&type=template&id=9a362b4a&scoped=true"
import script from "./DetalharPessoaJuridica.vue?vue&type=script&lang=js"
export * from "./DetalharPessoaJuridica.vue?vue&type=script&lang=js"

import "./DetalharPessoaJuridica.vue?vue&type=style&index=0&id=9a362b4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a362b4a"]])

export default __exports__